export enum TipoConta {
  ContaCorrente = 'ContaCorrente',
  ContaPoupanca = 'ContaPoupanca',
  ContaSalario = 'ContaSalario'
}
